import React, { useContext } from "react";
import ECLSelect from "../../../../ECLInputs/ECLSelect/ECLSelect";
import { ToastContext } from "../../../../../utilities/contexts";
import availableAggregations from "../../../../../utilities/availableAggregations";
import "./PivotTableSettings.css";
import { translate } from "../../../../../utilities/Translate";
import ECLNumber from "../../../../ECLInputs/ECLNumber/ECLNumber";
import ECLThemeImage from "../../../../Widgets/ECLThemeImage/ECLThemeImage";
import useSelectorId from "../../../../../utilities/hooks/useSelectorId";

//props
// pivotSettings - current state of pivot settings
// setPivotSettings - function to update pivot settings

export default function PivotTableSettings(props) {
   const addToast = useContext(ToastContext);
   const instanceId = useSelectorId();
   const additionalFields = [
      "weighted average",
      "correlation",
      "spearman correlation",
      "percentile",
   ];

   return (
      <div className="pivot-table-settings-box">
         <div
            className="pivot-table-settings-combo"
            id={instanceId + "-pivot-dimensions"}
         >
            <div className="pivot-table-settings-combo-label">
               <label>{translate("Rows:")}</label>
               <div className="sortable-rows-container">
                  {props.pivotSettings.activeRows.map((r) => {
                     return <button key={r}>{r}</button>;
                  })}
               </div>
            </div>
            <ECLSelect
               containerId={instanceId + "-pivot-dimensions"}
               multiselect={true}
               options={props.pivotSettings.dimensions.map((d) => {
                  return {
                     id: d,
                     searchableString: d,
                     jsx: d,
                     selected: props.pivotSettings.activeRows.find(
                        (x) => x === d,
                     )
                        ? true
                        : false,
                  };
               })}
               setOptions={(updatedArray) => {
                  const selections = updatedArray.filter((d) => d.selected);
                  if (
                     selections.some((s) =>
                        props.pivotSettings.activeColumns.includes(s.id),
                     )
                  ) {
                     addToast(
                        "A dimension cannot be in both Rows and Columns",
                        "error",
                     );
                  } else {
                     props.setPivotSettings((prev) => {
                        return {
                           ...prev,
                           activeRows: updatedArray
                              .filter((a) => a.selected)
                              .map((a) => a.id),
                        };
                     });
                  }
               }}
            />
            <div className="pivot-table-settings-combo-label">
               <label>{translate("Columns: ")}</label>
               <div className="sortable-columns-container">
                  {props.pivotSettings.activeColumns.map((r) => {
                     return <button key={r}>{r}</button>;
                  })}
               </div>
            </div>
            <ECLSelect
               containerId={instanceId + "-pivot-dimensions"}
               multiselect={true}
               options={props.pivotSettings.dimensions.map((d) => {
                  return {
                     id: d,
                     searchableString: d,
                     jsx: d,
                     selected: props.pivotSettings.activeColumns.find(
                        (x) => x === d,
                     )
                        ? true
                        : false,
                  };
               })}
               setOptions={(updatedArray) => {
                  const selections = updatedArray.filter((d) => d.selected);
                  if (
                     selections.some((s) =>
                        props.pivotSettings.activeRows.includes(s.id),
                     )
                  ) {
                     addToast(
                        "A dimension cannot be in both Rows and Columns",
                        "error",
                     );
                  } else {
                     props.setPivotSettings((prev) => {
                        return {
                           ...prev,
                           activeColumns: updatedArray
                              .filter((a) => a.selected)
                              .map((a) => a.id),
                        };
                     });
                  }
               }}
            />
         </div>
         <div
            className="pivot-table-settings-combo"
            id={instanceId + "-pivot-measures-main"}
         >
            <label>{translate("Measures")}</label>
            <ECLSelect
               containerId={instanceId + "-pivot-measures-main"}
               multiselect={true}
               options={props.pivotSettings.measures.map((d) => {
                  return {
                     id: d,
                     searchableString: d,
                     jsx: d,
                     selected: props.pivotSettings.activeMeasures.find(
                        (x) => x.item_name === d,
                     )
                        ? true
                        : false,
                  };
               })}
               setOptions={(updatedArray) => {
                  props.setPivotSettings((prev) => {
                     return {
                        ...prev,
                        activeMeasures: updatedArray
                           .filter((a) => a.selected)
                           .map((a) => {
                              return {
                                 item_name: a.id,
                                 aggregations:
                                    props.pivotSettings.activeMeasures.find(
                                       (x) => a.id === x.item_name,
                                    )
                                       ? props.pivotSettings.activeMeasures.find(
                                            (x) => a.id === x.item_name,
                                         ).aggregations
                                       : [],
                              };
                           }),
                     };
                  });
               }}
            />
            <div
               className="pivot-table-settings-combo-measures"
               id={instanceId + "-pivot-measures-choices"}
            >
               {props.pivotSettings.activeMeasures.map(
                  (r, activeMeasureIndex) => {
                     return (
                        <div key={r.item_name}>
                           <label>{r.item_name}</label>
                           <ECLSelect
                              containerId={
                                 instanceId + "-pivot-measures-choices"
                              }
                              multiselect={true}
                              options={availableAggregations().map((d) => {
                                 return {
                                    id: d,
                                    searchableString: d,
                                    jsx: (
                                       <div className="measure-label">{d}</div>
                                    ),
                                    selected: r.aggregations.find(
                                       (a) => a.type === d,
                                    )
                                       ? true
                                       : false,
                                 };
                              })}
                              setOptions={(updatedArray) => {
                                 props.setPivotSettings((prev) => {
                                    return {
                                       ...prev,
                                       activeMeasures: prev.activeMeasures.map(
                                          (m) => {
                                             if (m.item_name === r.item_name) {
                                                return {
                                                   item_name: m.item_name,
                                                   aggregations: updatedArray
                                                      .filter((a) => a.selected)
                                                      .map((a) => {
                                                         const previousValue =
                                                            m.aggregations.find(
                                                               (ag) =>
                                                                  ag.type ===
                                                                  a.id,
                                                            );
                                                         return {
                                                            type: a.id,
                                                            weighting_items:
                                                               previousValue?.weighting_items
                                                                  ? previousValue.weighting_items
                                                                  : [],
                                                            correlation_items:
                                                               previousValue?.correlation_items
                                                                  ? previousValue.correlation_items
                                                                  : [],
                                                            spearman_correlation_items:
                                                               previousValue?.spearman_correlation_items
                                                                  ? previousValue.spearman_correlation_items
                                                                  : [],
                                                            percentiles:
                                                               previousValue?.percentiles
                                                                  ? previousValue.percentiles
                                                                  : [],
                                                         };
                                                      }),
                                                };
                                             } else {
                                                return m;
                                             }
                                          },
                                       ),
                                    };
                                 });
                              }}
                           />
                           {additionalFields.some((a) =>
                              r.aggregations.find((ag) => ag.type === a),
                           ) && (
                              <div
                                 className="pivot-table-settings-combo-measure-additional"
                                 id={
                                    instanceId +
                                    "-pivot-measures-choices-additional" +
                                    activeMeasureIndex
                                 }
                              >
                                 {r.aggregations.map((ag) => {
                                    if (ag.type === "weighted average") {
                                       return (
                                          <div key={ag.type}>
                                             <label>
                                                {translate("Weighted Item")}
                                             </label>
                                             <ECLSelect
                                                containerId={
                                                   instanceId +
                                                   "-pivot-measures-choices-additional" +
                                                   activeMeasureIndex
                                                }
                                                multiselect={true}
                                                options={props.pivotSettings.measures
                                                   .filter(
                                                      (m) => m !== r.item_name,
                                                   )
                                                   .map((m) => {
                                                      return {
                                                         id: m,
                                                         searchableString: m,
                                                         jsx: m,
                                                         selected:
                                                            ag.weighting_items.includes(
                                                               m,
                                                            ),
                                                      };
                                                   })}
                                                setOptions={(updatedArray) => {
                                                   props.setPivotSettings(
                                                      (prev) => {
                                                         return {
                                                            ...prev,
                                                            activeMeasures:
                                                               prev.activeMeasures.map(
                                                                  (m) => {
                                                                     if (
                                                                        m.item_name ===
                                                                        r.item_name
                                                                     ) {
                                                                        return {
                                                                           ...m,
                                                                           aggregations:
                                                                              m.aggregations.map(
                                                                                 (
                                                                                    a,
                                                                                 ) => {
                                                                                    if (
                                                                                       a.type ===
                                                                                       "weighted average"
                                                                                    ) {
                                                                                       return {
                                                                                          ...a,
                                                                                          weighting_items:
                                                                                             updatedArray
                                                                                                .filter(
                                                                                                   (
                                                                                                      ua,
                                                                                                   ) =>
                                                                                                      ua.selected,
                                                                                                )
                                                                                                .map(
                                                                                                   (
                                                                                                      ua,
                                                                                                   ) =>
                                                                                                      ua.id,
                                                                                                ),
                                                                                       };
                                                                                    } else {
                                                                                       return a;
                                                                                    }
                                                                                 },
                                                                              ),
                                                                        };
                                                                     } else {
                                                                        return m;
                                                                     }
                                                                  },
                                                               ),
                                                         };
                                                      },
                                                   );
                                                }}
                                             />
                                          </div>
                                       );
                                    } else if (ag.type === "correlation") {
                                       return (
                                          <div key={ag.type}>
                                             <label>
                                                {translate(
                                                   "Correlate With (Pearsons)",
                                                )}
                                             </label>
                                             <ECLSelect
                                                containerId={
                                                   instanceId +
                                                   "-pivot-measures-choices-additional" +
                                                   activeMeasureIndex
                                                }
                                                multiselect={true}
                                                options={props.pivotSettings.measures
                                                   .filter(
                                                      (m) => m !== r.item_name,
                                                   )
                                                   .map((m) => {
                                                      return {
                                                         id: m,
                                                         searchableString: m,
                                                         jsx: m,
                                                         selected:
                                                            ag.correlation_items.includes(
                                                               m,
                                                            ),
                                                      };
                                                   })}
                                                setOptions={(updatedArray) => {
                                                   props.setPivotSettings(
                                                      (prev) => {
                                                         return {
                                                            ...prev,
                                                            activeMeasures:
                                                               prev.activeMeasures.map(
                                                                  (m) => {
                                                                     if (
                                                                        m.item_name ===
                                                                        r.item_name
                                                                     ) {
                                                                        return {
                                                                           ...m,
                                                                           aggregations:
                                                                              m.aggregations.map(
                                                                                 (
                                                                                    a,
                                                                                 ) => {
                                                                                    if (
                                                                                       a.type ===
                                                                                       "correlation"
                                                                                    ) {
                                                                                       return {
                                                                                          ...a,
                                                                                          correlation_items:
                                                                                             updatedArray
                                                                                                .filter(
                                                                                                   (
                                                                                                      ua,
                                                                                                   ) =>
                                                                                                      ua.selected,
                                                                                                )
                                                                                                .map(
                                                                                                   (
                                                                                                      ua,
                                                                                                   ) =>
                                                                                                      ua.id,
                                                                                                ),
                                                                                       };
                                                                                    } else {
                                                                                       return a;
                                                                                    }
                                                                                 },
                                                                              ),
                                                                        };
                                                                     } else {
                                                                        return m;
                                                                     }
                                                                  },
                                                               ),
                                                         };
                                                      },
                                                   );
                                                }}
                                             />
                                          </div>
                                       );
                                    } else if (
                                       ag.type === "spearman correlation"
                                    ) {
                                       return (
                                          <div key={ag.type}>
                                             <label>
                                                {translate(
                                                   "Correlate With (Spearman",
                                                )}
                                             </label>
                                             <ECLSelect
                                                containerId={
                                                   instanceId +
                                                   "-pivot-measures-choices-additional" +
                                                   activeMeasureIndex
                                                }
                                                multiselect={true}
                                                options={props.pivotSettings.measures
                                                   .filter(
                                                      (m) => m !== r.item_name,
                                                   )
                                                   .map((m) => {
                                                      return {
                                                         id: m,
                                                         searchableString: m,
                                                         jsx: m,
                                                         selected:
                                                            ag.spearman_correlation_items.includes(
                                                               m,
                                                            ),
                                                      };
                                                   })}
                                                setOptions={(updatedArray) => {
                                                   props.setPivotSettings(
                                                      (prev) => {
                                                         return {
                                                            ...prev,
                                                            activeMeasures:
                                                               prev.activeMeasures.map(
                                                                  (m) => {
                                                                     if (
                                                                        m.item_name ===
                                                                        r.item_name
                                                                     ) {
                                                                        return {
                                                                           ...m,
                                                                           aggregations:
                                                                              m.aggregations.map(
                                                                                 (
                                                                                    a,
                                                                                 ) => {
                                                                                    if (
                                                                                       a.type ===
                                                                                       "spearman correlation"
                                                                                    ) {
                                                                                       return {
                                                                                          ...a,
                                                                                          spearman_correlation_items:
                                                                                             updatedArray
                                                                                                .filter(
                                                                                                   (
                                                                                                      ua,
                                                                                                   ) =>
                                                                                                      ua.selected,
                                                                                                )
                                                                                                .map(
                                                                                                   (
                                                                                                      ua,
                                                                                                   ) =>
                                                                                                      ua.id,
                                                                                                ),
                                                                                       };
                                                                                    } else {
                                                                                       return a;
                                                                                    }
                                                                                 },
                                                                              ),
                                                                        };
                                                                     } else {
                                                                        return m;
                                                                     }
                                                                  },
                                                               ),
                                                         };
                                                      },
                                                   );
                                                }}
                                             />
                                          </div>
                                       );
                                    } else if (ag.type === "percentile") {
                                       return (
                                          <div key={ag.type}>
                                             <label>
                                                {translate("Percentile")}
                                             </label>
                                             {ag.percentiles.map((p, i) => {
                                                return (
                                                   <div
                                                      key={i}
                                                      className="percentile-combo"
                                                   >
                                                      <ECLNumber
                                                         min={0}
                                                         max={100}
                                                         precision={0}
                                                         stateValue={p}
                                                         onChange={(e) => {
                                                            const val = Number(
                                                               e.target.value,
                                                            );
                                                            if (
                                                               val >= 0 &&
                                                               val <= 100
                                                            ) {
                                                               props.setPivotSettings(
                                                                  (prev) => {
                                                                     return {
                                                                        ...prev,
                                                                        activeMeasures:
                                                                           prev.activeMeasures.map(
                                                                              (
                                                                                 m,
                                                                              ) => {
                                                                                 if (
                                                                                    m.item_name ===
                                                                                    r.item_name
                                                                                 ) {
                                                                                    return {
                                                                                       ...m,
                                                                                       aggregations:
                                                                                          m.aggregations.map(
                                                                                             (
                                                                                                a,
                                                                                             ) => {
                                                                                                if (
                                                                                                   a.type ===
                                                                                                   "percentile"
                                                                                                ) {
                                                                                                   let percentileCopy =
                                                                                                      [
                                                                                                         ...a.percentiles,
                                                                                                      ];
                                                                                                   percentileCopy[
                                                                                                      i
                                                                                                   ] =
                                                                                                      val;
                                                                                                   return {
                                                                                                      ...a,
                                                                                                      percentiles:
                                                                                                         percentileCopy,
                                                                                                   };
                                                                                                } else {
                                                                                                   return a;
                                                                                                }
                                                                                             },
                                                                                          ),
                                                                                    };
                                                                                 } else {
                                                                                    return m;
                                                                                 }
                                                                              },
                                                                           ),
                                                                     };
                                                                  },
                                                               );
                                                            }
                                                         }}
                                                      />
                                                      <button
                                                         onClick={(e) => {
                                                            e.preventDefault();
                                                            props.setPivotSettings(
                                                               (prev) => {
                                                                  return {
                                                                     ...prev,
                                                                     activeMeasures:
                                                                        prev.activeMeasures.map(
                                                                           (
                                                                              m,
                                                                           ) => {
                                                                              if (
                                                                                 m.item_name ===
                                                                                 r.item_name
                                                                              ) {
                                                                                 return {
                                                                                    ...m,
                                                                                    aggregations:
                                                                                       m.aggregations.map(
                                                                                          (
                                                                                             a,
                                                                                          ) => {
                                                                                             if (
                                                                                                a.type ===
                                                                                                "percentile"
                                                                                             ) {
                                                                                                let percentileCopy =
                                                                                                   [
                                                                                                      ...a.percentiles,
                                                                                                   ];
                                                                                                percentileCopy.splice(
                                                                                                   i,
                                                                                                   1,
                                                                                                );
                                                                                                return {
                                                                                                   ...a,
                                                                                                   percentiles:
                                                                                                      percentileCopy,
                                                                                                };
                                                                                             } else {
                                                                                                return a;
                                                                                             }
                                                                                          },
                                                                                       ),
                                                                                 };
                                                                              } else {
                                                                                 return m;
                                                                              }
                                                                           },
                                                                        ),
                                                                  };
                                                               },
                                                            );
                                                         }}
                                                      >
                                                         <ECLThemeImage fontAwesome="trash" />
                                                      </button>
                                                   </div>
                                                );
                                             })}

                                             <button
                                                onClick={(e) => {
                                                   e.preventDefault();
                                                   props.setPivotSettings(
                                                      (prev) => {
                                                         return {
                                                            ...prev,
                                                            activeMeasures:
                                                               prev.activeMeasures.map(
                                                                  (m) => {
                                                                     if (
                                                                        m.item_name ===
                                                                        r.item_name
                                                                     ) {
                                                                        return {
                                                                           ...m,
                                                                           aggregations:
                                                                              m.aggregations.map(
                                                                                 (
                                                                                    a,
                                                                                 ) => {
                                                                                    if (
                                                                                       a.type ===
                                                                                       "percentile"
                                                                                    ) {
                                                                                       return {
                                                                                          ...a,
                                                                                          percentiles:
                                                                                             [
                                                                                                ...a.percentiles,
                                                                                                50,
                                                                                             ],
                                                                                       };
                                                                                    } else {
                                                                                       return a;
                                                                                    }
                                                                                 },
                                                                              ),
                                                                        };
                                                                     } else {
                                                                        return m;
                                                                     }
                                                                  },
                                                               ),
                                                         };
                                                      },
                                                   );
                                                }}
                                             >
                                                {translate("Add New")}
                                             </button>
                                          </div>
                                       );
                                    } else {
                                       return null;
                                    }
                                 })}
                              </div>
                           )}
                        </div>
                     );
                  },
               )}
            </div>
         </div>
      </div>
   );
}
